export interface GetInspectionListRequest {
  id: number
  listType: InspectionListType
}

export const InspectionListType = {
  UnSelected: '',
  Unknown: '01',
  ContinuationUnknown: '02',
  NewUnknown: '03',
  LostProcedure: '04',
  Discovery: '05',
  BranchDifference: '06',
  ShelfTypeDifference: '07',
  StatusInvalid: '08',
  ReserveReceipt: '09',
  CollectionTypeDifference: '10',
  Unregistered: '11'
} as const
export type InspectionListType = typeof InspectionListType[keyof typeof InspectionListType]

export function GetInspectionListRequestToJSON(
  value: GetInspectionListRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    list_type:
      value.listType !== InspectionListType.UnSelected
        ? value.listType
        : undefined
  }
}
